"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Margin = void 0;
var react_1 = __importStar(require("react"));
var arrays_1 = require("utils/arrays");
var components_1 = require("../components");
var nums = (0, arrays_1.range)(0, 10);
var Margin = function () { return (react_1.default.createElement(components_1.Section, { examples: react_1.default.createElement(react_1.Fragment, null,
        nums.map(function (val) { return (react_1.default.createElement(components_1.Box, { className: "m".concat(val, " p1"), key: val }, "m".concat(val))); }),
        nums.map(function (val) { return (react_1.default.createElement(components_1.Box, { className: "mx".concat(val, " p1"), key: val }, "mx".concat(val))); }),
        nums.map(function (val) { return (react_1.default.createElement(components_1.Box, { className: "ml".concat(val, " p1"), key: val }, "ml".concat(val))); }),
        nums.map(function (val) { return (react_1.default.createElement(components_1.Box, { className: "mr".concat(val, " p1"), key: val }, "mr".concat(val))); }),
        nums.map(function (val) { return (react_1.default.createElement(components_1.Box, { className: "my".concat(val, " p1"), key: val }, "my".concat(val))); }),
        nums.map(function (val) { return (react_1.default.createElement(components_1.Box, { className: "mt".concat(val, " p1"), key: val }, "mt".concat(val))); }),
        nums.map(function (val) { return (react_1.default.createElement(components_1.Box, { className: "mb".concat(val, " p1"), key: val }, "mb".concat(val))); })), id: "margin", title: "Margin" })); };
exports.Margin = Margin;
